import React from "react";

function ContactArrow() {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 492 493"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.30469"
        y="429.751"
        width="606.528"
        height="86.8419"
        transform="rotate(-45 1.30469 429.751)"
        fill="#232323"
      />
      <rect
        x="368.781"
        y="62.272"
        width="86.8419"
        height="86.8419"
        transform="rotate(-45 368.781 62.272)"
        fill="#232323"
      />
      <rect
        x="368.781"
        y="185.084"
        width="86.8419"
        height="86.8419"
        transform="rotate(-45 368.781 185.084)"
        fill="#232323"
      />
      <rect
        x="368.781"
        y="307.896"
        width="86.8419"
        height="86.8419"
        transform="rotate(-45 368.781 307.896)"
        fill="#232323"
      />
      <rect
        x="368.781"
        y="430.708"
        width="86.8419"
        height="86.8419"
        transform="rotate(-45 368.781 430.708)"
        fill="#232323"
      />
      <rect
        x="184.582"
        y="123.678"
        width="86.8419"
        height="86.8419"
        transform="rotate(-135 184.582 123.678)"
        fill="#232323"
      />
      <rect
        x="61.7734"
        y="123.678"
        width="86.8419"
        height="86.8419"
        transform="rotate(-135 61.7734 123.678)"
        fill="#232323"
      />
      <rect
        x="307.383"
        y="123.678"
        width="86.8419"
        height="86.8419"
        transform="rotate(-135 307.383 123.678)"
        fill="#232323"
      />
      <rect
        x="430.227"
        y="123.678"
        width="86.8419"
        height="86.8419"
        transform="rotate(-135 430.227 123.678)"
        fill="#232323"
      />
    </svg>
  );
}

export default ContactArrow;
